import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { RightClickMenuOption } from '@prism/prism-shared';
import { BehaviorSubject, delay, Observable, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ScreenService {

    
    public disableMaxWidth$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public hideMainHeader$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public showRefreshButton$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public disableScroll$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public disableBackgroundColor$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public disableExpandScrollbarOnHover$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public displayFullPageLoadingSpinner$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    /** Optional line shown under the full page spinner; cleared by whoever set it. */
    public fullPageLoadingSpinnerMessage$: BehaviorSubject<string> = new BehaviorSubject<string>('');
    public disablePageZoom$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    // reference RIGHT_CLICKABLE_CLASS_NAME for how to use
    public customRightClickMenuOptions$: BehaviorSubject<RightClickMenuOption[]> = new BehaviorSubject<RightClickMenuOption[]>([]);
    public customRightClickElementId$: BehaviorSubject<string> = new BehaviorSubject<string>('');

    private preventZoom = (e: TouchEvent) => {
        if (e.touches.length > 1) {
            e.preventDefault();
        }
    }

    private preventGesture = (e: Event) => {
        e.preventDefault();
    }

    constructor(
        @Inject(DOCUMENT) private document: Document
    ) {
        this.disableExpandScrollbarOnHover$.pipe(
            tap((disableExpandScrollbarOnHover) => {
                if (disableExpandScrollbarOnHover) {
                    this.document.documentElement.style.setProperty(
                        '--scrollbar-hover-width',
                        '3px'
                    );
                } else {
                    this.document.documentElement.style.setProperty(
                        '--scrollbar-hover-width',
                        '1rem'
                    );
                }
            })
        ).subscribe()

        this.disablePageZoom$.pipe(
            tap((disablePageZoom) => {
                if (disablePageZoom) {
                    // Add CSS touch-action
                    this.document.body.style.touchAction = 'pan-x pan-y';

                    // Prevent multi-touch zoom
                    this.document.addEventListener('touchmove', this.preventZoom, { passive: false });
                    this.document.addEventListener('gesturestart', this.preventGesture, { passive: false });
                    this.document.addEventListener('gesturechange', this.preventGesture, { passive: false });
                    this.document.addEventListener('gestureend', this.preventGesture, { passive: false });
                } else {
                    // Remove CSS touch-action
                    this.document.body.style.touchAction = '';

                    // Remove event listeners
                    this.document.removeEventListener('touchmove', this.preventZoom);
                    this.document.removeEventListener('gesturestart', this.preventGesture);
                    this.document.removeEventListener('gesturechange', this.preventGesture);
                    this.document.removeEventListener('gestureend', this.preventGesture);
                }
            })
        ).subscribe()
    }

    public reset() {
        this.disableMaxWidth$.next(false);
        this.hideMainHeader$.next(false);
        this.showRefreshButton$.next(false);
        this.disableScroll$.next(false);
        this.disableBackgroundColor$.next(false)
        this.disableExpandScrollbarOnHover$.next(false)
        this.customRightClickMenuOptions$.next([])
        this.customRightClickElementId$.next('')
        this.displayFullPageLoadingSpinner$.next(false);
        this.disablePageZoom$.next(false);
    }

}